import { useQuery, useSubscription } from "@apollo/react-hooks";
import { GET_NOT_AUTHORIZED_LIST } from "my-time/graphql/queries";
import { MY_TIME_REQUESTS_SUBSCRIPTION } from "my-time/graphql/subscriptions";

export const useMyTimeNotAuthorizedList = () => {
  const { data, loading, error, refetch } = useQuery(GET_NOT_AUTHORIZED_LIST, {
    fetchPolicy: "cache-and-network",
  });

  useSubscription(MY_TIME_REQUESTS_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    onData: () => {
      refetch();
    },
  });

  return {
    data: data?.notAuthorizedList || [],
    loading,
    error,
    refetch,
  };
};

export default useMyTimeNotAuthorizedList;
